var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$vuetify.breakpoint.mobile)?_c('CrisantemiDesktop'):_c('v-card',{staticClass:"pa-6 text-center grey--text"},[_vm._v(" Il modulo crisantemi è disponibile solo su desktop. ")])}
var staticRenderFns = []

export { render, staticRenderFns }